export default "__VITE_ASSET__8dNNfBbO__"